// Imports
import React from 'react';
import styled from 'styled-components/macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp } from '@fortawesome/pro-light-svg-icons';


// Styled components
const Container = styled.th`
	cursor: pointer;
	min-width: 10rem;
	
	> svg.sorting-indicator {
		margin-left: -0.5em;
		transform: translateX(1em);
	}
`;


// Define the accepted props
interface Props {
	indicator?: 'ascending' | 'descending';
}


// Function component
const SortableTableHeader: React.FC<Props & React.ThHTMLAttributes<HTMLTableCellElement>> = ({
	children,
	indicator,
	...passThroughProps
}) => {
	return (
		<Container {...passThroughProps}>
			{children}
			{indicator && (
				<FontAwesomeIcon icon={indicator === 'ascending' ? faAngleUp : faAngleDown} className='sorting-indicator' />
			)}
		</Container>
	);
};

export default SortableTableHeader;
